import styled from 'styled-components'
import FlyoutWithMobileSlideUp from 'components/FlyoutWithMobileSlideUp'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

import { Button } from 'common-components'
import { premiumButtonStyles } from 'containers/SubSidebar/styled'

export const CtaButton = styled(Button)<{ $isPremium: boolean }>`
  width: 100%;
  ${premiumButtonStyles}
`
export const Flyout = styled(FlyoutWithMobileSlideUp)`
  border-radius: 10px;
  overflow: hidden;
`
export const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  /* A long localized CTA label (ru "Изменить размер", es "Redimensionar")
     must widen the panel (see PanelContainer's max-content width), never wrap
     inside the button. */
  white-space: nowrap;
`

export const PanelContainer = styled.div<{ $hasDescription?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  /* Description panels (Enhance) read best at a fixed 280px line length.
     Content-only panels (Resize) size to their content instead — a hard 200px
     overflowed with long localized CTA labels — bounded to the same 280px. */
  width: ${props => (props.$hasDescription ? '280px' : 'max-content')};
  min-width: 200px;
  max-width: 280px;
  background: ${COLORS.white};
  /* Inside the mobile SlideUp the sheet's height is capped
     (max-height: calc(100% - 148px)); scroll the panel body instead of pushing
     the CTA below the fold. min-height: 0 lets the flex child actually shrink.
     No-op on desktop where the flyout grows to fit. */
  overflow-y: auto;
  min-height: 0;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    /* Inside the mobile SlideUp the panel fills the sheet — the desktop
       280px cap must not apply. */
    width: 100%;
    max-width: 100%;
  }
`

export const PanelTitle = styled.h3`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: ${COLORS.secondaryDark};
`

export const PanelText = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 18px;
  color: ${COLORS.secondarySemiDark};
`

export const CreditsBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`

export const ThunderIcon = styled.img`
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
`
